import{createStyles as t}from"../../theme/utils/create-styles.js";var o=t({root:{"&.ant-modal":{paddingBottom:0}},withoutFooterButtons:{"& .ant-modal-footer":{display:"none"}}});export{o as styles};
